import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { PageHeader } from 'components/PageHeader'

import { CampaignsList } from './CampaignsList'
import { VouchersList } from '../Vouchers'

const TABS = [
  { key: 'campanas', label: 'Campañas' },
  { key: 'vouchers', label: 'Vouchers' },
]

const Campaigns: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabFromUrl = searchParams.get('tab')
  const initialTab = tabFromUrl === 'vouchers' ? 'vouchers' : 'campanas'
  const [activeTab, setActiveTab] = useState(initialTab)

  useEffect(() => {
    if (tabFromUrl === 'vouchers' && activeTab !== 'vouchers') {
      setActiveTab('vouchers')
    }
  }, [tabFromUrl, activeTab])

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey)
    if (tabKey === 'vouchers') {
      setSearchParams({ tab: 'vouchers' })
    } else {
      setSearchParams({})
    }
  }

  return (
    <>
      <PageHeader
        title="Campañas"
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      {activeTab === 'campanas' ? <CampaignsList /> : <VouchersList />}
    </>
  )
}

export { Campaigns }
